import { render, staticRenderFns } from "./CategorySubMenu.vue?vue&type=template&id=71d22580&"
import script from "./CategorySubMenu.vue?vue&type=script&lang=js&"
export * from "./CategorySubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports